import { render } from "./my_orders.vue?vue&type=template&id=44b73ba8&scoped=true"
import script from "./my_orders.vue?vue&type=script&lang=js"
export * from "./my_orders.vue?vue&type=script&lang=js"

import "./my_orders.vue?vue&type=style&index=0&id=44b73ba8&scoped=true&lang=css"
import "./my_orders.vue?vue&type=style&index=1&id=44b73ba8&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b73ba8"]])

export default __exports__